import { Routes, Route, Navigate } from "react-router-dom";
import { useRole } from "./RoleContext";
import SocioLayout from "./Components/layouts/layoutSocio.js";
import MainLayout from "./Components/layouts/latyoutMain.js";
import PrivateRoute from "./Components/middleware/PrivateRoute";
import { Unauthorized } from "./Components/unauthorized.js";

import Login from "./Components/Login";
import LoginSocio from "./Components/LoginSocio.js";
import Inicio from "./Components/Inicio";
import List from "./Components/List";
import Create from "./Components/Create";
import Edit from "./Components/Edit";
import Upload from "./Components/Upload";
import Buscar from "./Components/Buscar";
import Buscar2 from "./Components/Buscar2";
import FichaRut from "./Components/Ficha";
import FichaSocio from "./Components/FichaSocio.js";
import CrearFamilia from "./Components/AdmFamilia";
import Bitacora from "./Components/Bitacora";
import Cursos from "./Components/cursos";
import CrearCurso from "./Components/CrearCurso";
import EditarCurso from "./Components/EditarCurso";
import Contabilidad from "./Components/Contabilidad";
import ReportesContables from "./Components/ReportesContables";
import CrearUsuario from "./Components/CrearUsuario";
import CambiarPassword from "./Components/CambiarPassword";
import CambiarPasswordSocio from "./Components/CambiarPasswordSocio.jsx";
import Informaciones from "./Components/Informaciones";
import PanelAdm from "./Components/PanelAdm";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { UnauthorizedS } from "./Components/unauthorizedS.js";



function App() {
  const { token } = useRole();


  return (
        <div className="App-header">
          {!token ? (
            <>
              <Routes>
                <Route path="/" element={<Navigate to="/login" />} />
                <Route path="/inicio" element={<Navigate to="/" />} />
                <Route path="/login" element={<Login />} />
                <Route path="/login/socio" element={<LoginSocio />} />
              </Routes>
            </>
          ) : (
            <>
              {/* 🧩 Layout principal */}
              <Routes>
                <Route element={<MainLayout />}>
                  <Route path="/" element={<PrivateRoute allowedRoles={["Administrador", "Contador", "Secretario", "Digitador", "Lector", "Ejecutivo"]}><Inicio /></PrivateRoute>} />
                  <Route path="/inicio" element={<PrivateRoute allowedRoles={["Administrador", "Contador", "Secretario", "Digitador", "Lector", "Ejecutivo"]}><Inicio /></PrivateRoute>} />
                  <Route path="/mostrar" element={<PrivateRoute allowedRoles={["Administrador", "Contador", "Secretario", "Digitador", "Lector", "Ejecutivo"]}><List /></PrivateRoute>} />
                  <Route path="/crear" element={<PrivateRoute allowedRoles={["Administrador", "Contador", "Secretario", "Digitador", "Lector", "Ejecutivo"]}><Create /></PrivateRoute>} />
                  <Route path="/subir" element={<PrivateRoute allowedRoles={["Administrador", "Contador", "Secretario", "Digitador", "Lector", "Ejecutivo"]}><Upload /></PrivateRoute>} />
                  <Route path="/editar" element={<PrivateRoute allowedRoles={["Administrador", "Contador", "Secretario", "Digitador", "Lector", "Ejecutivo"]}><Buscar /></PrivateRoute>} />
                  <Route path="/editar/:rut" element={<PrivateRoute allowedRoles={["Administrador", "Contador", "Secretario", "Digitador", "Lector", "Ejecutivo"]}><Edit /></PrivateRoute>} />
                  <Route path="/ficha" element={<PrivateRoute allowedRoles={["Administrador", "Contador", "Secretario", "Digitador", "Lector", "Ejecutivo"]}><Buscar2 /></PrivateRoute>} />
                  <Route path="/ficha/:rut" element={<PrivateRoute allowedRoles={["Administrador", "Contador", "Secretario", "Digitador", "Lector", "Ejecutivo"]}><FichaRut /></PrivateRoute>} />
                  <Route path="/crearfamilia" element={<PrivateRoute allowedRoles={["Administrador"]}><CrearFamilia /></PrivateRoute>} />
                  <Route path="/bitacora" element={<PrivateRoute allowedRoles={["Administrador", "Contador", "Secretario", "Digitador", "Lector", "Ejecutivo"]}><Bitacora /></PrivateRoute>} />
                  <Route path="/cursos" element={<PrivateRoute allowedRoles={["Administrador", "Contador", "Secretario", "Digitador", "Lector", "Ejecutivo"]}><Cursos /></PrivateRoute>} />
                  <Route path="/crearcurso" element={<PrivateRoute allowedRoles={["Administrador", "Digitador"]}><CrearCurso /></PrivateRoute>} />
                  <Route path="/editarcurso/:id" element={<PrivateRoute allowedRoles={["Administrador"]}><EditarCurso /></PrivateRoute>} />
                  <Route path="/contabilidad" element={<PrivateRoute allowedRoles={["Administrador", "Contador", "Secretario", "Digitador", "Lector", "Ejecutivo"]}><Contabilidad /></PrivateRoute>} />
                  <Route path="/reportes" element={<PrivateRoute allowedRoles={["Administrador", "Contador"]}><ReportesContables /></PrivateRoute>} />
                  <Route path="/usuarios" element={<PrivateRoute allowedRoles={["Administrador", "Contador", "Secretario", "Digitador", "Lector", "Ejecutivo"]}><CrearUsuario /></PrivateRoute>} />
                  <Route path="/cambiar-contraseña" element={<PrivateRoute allowedRoles={["Administrador", "Contador", "Secretario", "Digitador", "Lector", "Ejecutivo"]}><CambiarPassword /></PrivateRoute>} />
                  <Route path="/informaciones" element={<PrivateRoute allowedRoles={["Administrador", "Secretario"]}><Informaciones /></PrivateRoute>} />
                  <Route path="/panel-adm" element={<PrivateRoute allowedRoles={["Administrador"]}><PanelAdm /></PrivateRoute>} />
                  <Route path="/unauthorized" element={<Unauthorized />} />
                </Route>

                  
                {/* 🧩 Layout de socios */}
                <Route element={<SocioLayout />}>
                  <Route path="/ficha-socio/:rut" element={<FichaSocio />} />
                  <Route path="/socio/cambiar-contraseña" element={<CambiarPasswordSocio />} />
                  <Route path="/unauthorized" element={<UnauthorizedS />} />
                </Route>
              </Routes>
            </>
          )}

          <footer className="App-footer">
            © 2025 Todos los derechos reservados. | Obra Kolping | Chile
          </footer>
        </div>
  );
}

export default App;
